"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSharingConfiguration = void 0;
var _axios = require("@ori/axios");
var _checkoutUtils = require("@ori/checkout-utils");
var _fetching = require("@ori/fetching");
var _constants = require("../constants");
var _logger = require("../logger");
var _types = require("../types");
var _utils = require("../utils");
var _showAllVendorsSetting = require("../utils/showAllVendorsSetting");
const useSharingConfiguration = (capabilities, isCopyLinkIconDisplayed) => {
  (0, _logger.logDebug)('useSharingConfiguration hook called.');
  const areAllVendorsEnabled = (0, _showAllVendorsSetting.shouldShowAllVendors)();
  let enabledVendors = [];
  const vendors = Object.keys(_types.sharingVendorsConfig);
  // TO-DO: use API /applications/socialMediaLibrary/configuration
  const configUrl = new URL('/system/ajax/social/socialSharingConfiguration?sharingForCatalogue=false', window.location.origin);
  const {
    data,
    error,
    isValidating
  } = (0, _fetching.useSWR)(areAllVendorsEnabled ? null : configUrl.toString(), async url => _axios.axios.get(url).then(response => response.data), {
    ..._checkoutUtils.basicSwrOptions,
    revalidateIfStale: false
  });
  if (isValidating) {
    (0, _logger.logDebug)(`Loading configuration data from ${configUrl} ...`);
  }
  if (areAllVendorsEnabled) {
    // return all vendors for testing
    enabledVendors = vendors;
    if (!isCopyLinkIconDisplayed) {
      enabledVendors = enabledVendors.filter(item => item !== _constants.COPY_LINK_KEY);
    }
    (0, _logger.logDebug)(`All vendors ${isCopyLinkIconDisplayed ? '' : 'except of copy link '}will be shown.`, `Switch the '${_constants.SHOW_ALL_VENDORS_KEY}' localStorage flag off to see actual configured vendors.`);
  } else {
    if (error) {
      _logger.mainLogger.error(error, {
        action: 'useSharingConfiguration'
      });
    }
    if (data) {
      // filter according to per market config & only those with getSharingLink
      // other props returned by the config: cssClass, localizationDictionaryItem
      const keys = new Set(data.integrations.sites.map(item => item.jsClass));
      // add same structure for the copy link "vendor" if enabled
      if (isCopyLinkIconDisplayed) {
        keys.add(_constants.COPY_LINK_KEY);
      } else {
        keys.delete(_constants.COPY_LINK_KEY);
      }
      enabledVendors = vendors.filter(key => {
        const {
          actionType,
          capabilities: vendorCapabilities,
          getSharingLink,
          integrationKey
        } = _types.sharingVendorsConfig[key];
        const searchedKey = integrationKey ?? key;
        // check also capabilities if provided
        const capabilitiesMatch = (0, _utils.doCapabilitiesMatch)(capabilities, vendorCapabilities);
        return Boolean(getSharingLink) && (actionType === _types.SharingActionType.CopyLinkDialog || capabilitiesMatch) && keys.has(searchedKey);
      });
    }
  }
  if (!isValidating) {
    (0, _logger.logDebug)('Enabled social vendors:', enabledVendors.join(', ') || '<none>');
  }
  return {
    enabledVendors,
    error,
    isLoadingSharingConfig: areAllVendorsEnabled ? false : isValidating
  };
};
exports.useSharingConfiguration = useSharingConfiguration;
